<template>
  <div style="display: flex; flex-direction: column; gap: 16px">
    <!-- card principal: vendidos -->
    <v-card class="elevation-1">
      <div class="px-4 pt-3 pb-2" style="background: linear-gradient(to right, #0c2646, #2a5788)">
        <div class="d-flex align-center justify-space-between mb-1">
          <div class="d-flex align-center" style="gap: 8px; flex-wrap: wrap">
            <span class="headline font-weight-bold white--text">
              {{ meta.tipo_conteudo || "Chassi" }}
            </span>
            <v-chip
              v-if="meta.superou_gmr"
              x-small
              color="amber darken-1"
              class="font-weight-bold black--text"
            >
              <v-icon left x-small color="black">mdi-chevron-double-up</v-icon>
              {{ labelGmr }}
            </v-chip>
          </div>
          <span class="caption font-weight-bold" style="color: rgba(255,255,255,0.9)">#{{ meta.id_campanha_meta }}</span>
        </div>
        <div class="d-flex align-center flex-wrap" style="gap: 2px 12px">
          <span class="caption" style="color: rgba(255,255,255,0.9)">
            <span style="color: rgba(255,255,255,0.6)">Realizado: </span>
            <span class="font-weight-medium">{{ meta.tipo_realizado || "—" }}</span>
          </span>
          <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
          <span class="caption" style="color: rgba(255,255,255,0.9)">
            <span style="color: rgba(255,255,255,0.6)">Pagamento: </span>
            <span class="font-weight-medium">{{ meta.tipo_pagamento || labelPagamento }}</span>
          </span>
          <span class="caption" style="color: rgba(255,255,255,0.5)">·</span>
          <span class="caption" style="color: rgba(255,255,255,0.9)">
            <span style="color: rgba(255,255,255,0.6)">Participantes: </span>
            <span class="font-weight-medium">{{ meta.nParticipantes }}</span>
          </span>
        </div>
      </div>

      <!-- filtros -->
      <v-card-text class="pb-0">
        <v-row dense align="center">
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-autocomplete v-model="filters.empresa"    :items="opcoesEmpresa" label="Empresa"     clearable single-line dense />
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-autocomplete v-model="filters.funcao"     :items="opcoesFuncao"  label="Função"      clearable single-line dense />
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-autocomplete v-model="filters.chassi"     :items="opcoesChassi"  label="Chassi"      clearable single-line dense />
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2">
            <v-autocomplete v-model="filters.ganhouMeta" :items="simNao" item-text="text" item-value="value" label="Ganhou Meta" clearable single-line dense />
          </v-col>
        </v-row>
      </v-card-text>

      <ApuracaoTabelaChassi :rows="rowsFiltrados" :search="search" :gmr-info="gmrInfo" />

      <!-- footer -->
      <div class="d-flex justify-end align-center px-4 py-2" style="border-top: 1px solid rgba(0,0,0,0.12); background: rgba(0,0,0,0.02); gap: 16px">
        <span v-if="meta.superou_gmr && gmrInfo" class="caption amber--text text--darken-2 font-weight-medium">
          <v-icon x-small color="amber darken-2">mdi-chevron-double-up</v-icon>
          {{ labelGmr === '× 2' ? 'Bônus dobrado pelo GMR' : 'Bônus liberado' }}
        </span>
        <span class="caption grey--text text--darken-1">
          Custo Estimado:
          <strong class="ml-1">{{ custoEstimado | BrazilianCurrency }}</strong>
        </span>
        <span class="caption grey--text text--darken-1">
          Total Bônus Pago:
          <strong class="ml-1">{{ totalBonusPago | BrazilianCurrency }}</strong>
        </span>
      </div>
    </v-card>

    <!-- card chassis não vendidos -->
    <v-card class="elevation-1">
      <div class="px-4 pt-3 pb-2" style="background: linear-gradient(to right, #0c2646, #2a5788)">
        <span class="subtitle-1 font-weight-bold white--text">Chassis não vendidos</span>
      </div>
      <ApuracaoTabelaChassiNaoVendidos :rows="meta.rows" :search="search" />
    </v-card>
  </div>
</template>

<script>
import apuracaoTipoMixin from "@/mixins/apuracaoTipoMixin";
import ApuracaoTabelaChassi           from "../tabelas/ApuracaoTabelaChassi";
import ApuracaoTabelaChassiNaoVendidos from "../tabelas/ApuracaoTabelaChassiNaoVendidos";

export default {
  name: "ApuracaoChassi",

  components: { ApuracaoTabelaChassi, ApuracaoTabelaChassiNaoVendidos },

  mixins: [apuracaoTipoMixin],

  data() {
    return {
      simNao: [{ value: "S", text: "Sim" }, { value: "N", text: "Não" }]
    };
  },

  computed: {
    rowsFiltrados() {
      return this.rowsBase;
    },

    // Soma valor_bonus por chassi único, cada chassi só pode ser vendido uma vez
    custoEstimado() {
      const seen = new Set();
      let total = 0;
      for (const row of this.meta.rows) {
        if (!row.chassi_completo || seen.has(row.chassi_completo)) continue;
        seen.add(row.chassi_completo);
        total += parseFloat(row.valor_bonus) || 0;
      }
      return total;
    },

    labelPagamento() {
      return this.meta.id_tipo_pagamento == 1 ? "Por Unidade" : "Valor Fixo";
    }
  }
};
</script>
